import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { pmIntegrationSelector } from 'state/selectors/sensors-authorizations';
import { fetchIssuesData } from 'views/root/views/home/views/dashboard/components/StuckIssues/stuck-issues.service';

const useIssues = ({ issuesProps, isTeamPMConfigurationEnabled } = {}) => {
  const currentIteration = _.get(issuesProps, 'currentIteration');
  const selectedTeam = _.get(issuesProps, 'selectedTeam');

  if (!currentIteration || !selectedTeam)
    throw Error('issuesProps: {currentIteration, selectedTeam} are missing');

  const [issues, setIssues] = useState([]);
  const [isError, setIsError] = useState(false);

  const pmSensor = useSelector(pmIntegrationSelector);

  const getIssuesData = async () => {
    try {
      const { issues } = await fetchIssuesData(
        currentIteration,
        selectedTeam,
        pmSensor.sensor_id,
        isTeamPMConfigurationEnabled
      );
      setIssues(issues);
    } catch (e) {
      setIsError(true);
    }
  };

  useEffect(() => {
    const makeApiCall =
      currentIteration !== undefined &&
      selectedTeam !== undefined &&
      pmSensor?.sensor_id !== undefined;
    if (makeApiCall) {
      getIssuesData();
    }
  }, [currentIteration, selectedTeam]);

  return {
    issues,
    setIssues,
    isError,
    setIsError
  };
};

export default useIssues;
